<template>
	<div>
		<h2 class="text-center text-[20px] leading-[28px] font-semibold text-gray-900">
			Cancel Subscription
		</h2>
		<p class="mt-0.5 text-center text-[14px] leading-[20px] font-normal text-gray-500">
			Thank you for choosing WonsultingAI, we’re sorry to see you go.
			Before you cancel, please specify your reason of cancelation.
		</p>

		<div class="mt-6 flex flex-col gap-2">
			<button
				v-for="reason in CANCELLATION_REASONS"
				:key="reason.value"
				type="button"
				class="
					flex h-9 w-full items-center rounded-md border border-gray-200 bg-white px-3
					text-left text-[14px] leading-[20px] font-medium text-gray-900 hover:bg-gray-50
				"
				@click="emit('select', reason.value)"
			>
				{{ reason.label }}
			</button>
		</div>
	</div>
</template>

<script setup>
import { CANCELLATION_REASONS } from './reasons';

const emit = defineEmits(['select']);
</script>
